import React                      from 'react' ;
import { Empty }                  from 'antd' ;

import { IErrorToText
       , TEXT }                   from './00_assets_types' ;
import es                         from './21_assets_locale_es' ;
import en                         from './22_assets_locale_en' ;
import fr                         from './23_assets_locale_fr' ;
import de                         from './24_assets_locale_de' ;
import it                         from './25_assets_locale_it' ;
import pt                         from './26_assets_locale_pt' ;
import no                         from './27_assets_locale_no' ;
import cs                         from './28_assets_locale_cs' ;
import pl                         from './29_assets_locale_pl' ;
import da                         from './30_assets_locale_da' ;
import sv                         from './31_assets_locale_sv' ;
import eu                         from './32_assets_locale_eu' ;

import { observable }             from 'mobx' ;


const LANG_KEY = 'JMA_lang'
    , g_texts: { [key:string]: { [key:string]: string } } = { cs, da, de, en, es, eu, fr, it, no, pl, pt, sv}
    //, g_texts: { [key:string]: { [key:string]: string } } = { es, en , fr, de, it, pt, no, cs, pl, da, sv}
    , nav_language = navigator.language.slice(0, 2) || 'es'
    , DEFAULT_LANG = nav_language in g_texts? nav_language : 'en'

export type LANG = 'es' | 'en' ; // keyof g_texts does not work here
export const AVAIL_LANGS = Object.keys( g_texts ) ;

let g_lang = observable.box( DEFAULT_LANG ) ;


export function set_lang ( lang: LANG )
{
  g_lang.set( lang ) ;
  localStorage.setItem( LANG_KEY, lang ) ;
}

export function restore_lang ( )
{
  g_lang.set( localStorage.getItem( LANG_KEY ) || DEFAULT_LANG ) ;
}


export function tr_enum_key_application ( state: string )
{
  const convert: { [key: string]: TEXT } = { 
                    CAR        : TEXT.ENUM_KEY_APP_CAR
                  , HOME       : TEXT.ENUM_KEY_APP_HOME
                  , SECURITY   : TEXT.ENUM_KEY_APP_SECURITY
                  , LOCK       : TEXT.ENUM_KEY_APP_LOCK
                  , UNSPECIFIED: TEXT.ENUM_KEY_APP_UNSPECIFIED
                  } ;

  return tr( convert[ state ] as TEXT ) ;
}


export function tr_enum_job_state ( state: string )
{
  const convert: { [key: string]: TEXT } = { 
                    COMPLETE  : TEXT.ENUM_JOB_STATE_COMPLETE
                  , PENDING   : TEXT.ENUM_JOB_STATE_PENDING
                  , CANCELLED : TEXT.ENUM_JOB_STATE_CANCELLED
                  , PROCESSING: TEXT.ENUM_JOB_STATE_PROCESSING
                  } ;

  return state === '---'? state : tr( convert[ state ] as TEXT ) ;
}


export function tr_enum_role ( state: string )
{
  const convert: { [key: string]: TEXT } = { 
                    ADMIN  : TEXT.ENUM_USER_ROLE_ADMIN
                  , MANAGER: TEXT.ENUM_USER_ROLE_MANAGER
                  , USER   : TEXT.ENUM_USER_ROLE_USER
                  } ;

  return tr( convert[ state ] as TEXT ) ;
}


export function tr ( key: TEXT, opts: any = {} )
{
  let txt = g_texts[ current_lang( ) ][ key ] as string ;

  for ( const key in opts )
        txt = txt.replace( new RegExp( '{' + key + '}', 'g' ), opts[ key ] as string ) ;

  return txt ;
}


export function current_lang ( )
{
  return g_lang.get( ) as LANG
}


export function tr_error ( error: { code: number, msg?: string, message?: string }, msgs: IErrorToText )
{
  return error.code === undefined? error.message!
       : error.code === -1       ? (error.msg! || error.message!)
       :                           tr( msgs[ error.code ] ) ;
}

export const TABLE_LOCALE =
{
  emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={ tr( TEXT.UI_NO_DATA ) } /> 
}